import Image from 'app/Components/Shared/Image/image';
import React, {useCallback, useEffect} from 'react';
import {connect} from 'react-redux';
import {setCurrentStep, saveToHistory} from 'app/Components/Block/VisualIVRMenuBlock/VisualIVRSlice';
import {visualIvrSteps, visualIvrColors , previousPageButtonText} from 'app/Components/Block/VisualIVRMenuBlock/utils/constants';
import {getTextOrDefault, getImageUrlOrDefault} from 'app/Components/Block/BusinessDashboardBlock/utils/functions';
import previousPageIcon from 'app/Components/Block/VisualIVRMenuBlock/assets/Images/previousPageIcon.svg';
import IvrCategoryAction from 'app/Components/Block/VisualIVRMenuBlock/components/subComponents/IvrCategoryAction/IvrCategoryAction';
import Config from 'app/Config';

const VisualIvrActionsPage = ({categoryData, setCurrentStep, saveToHistory}) => {
  const {categoryName, actionsPageBackgroundImageUrl, actionsPageReturnButtonColor, actionsPageTitle, actionsPageTitleColor, categoryActionList} = categoryData || {};

  const actionsPageTitleColorStr = actionsPageTitleColor || visualIvrColors.BLACK;
  const returnButtonTextColor = actionsPageReturnButtonColor || visualIvrColors.BLACK;
  const actionsPageBackgroundImageFullUrl = actionsPageBackgroundImageUrl ? Config.epiBaseUrl + actionsPageBackgroundImageUrl : '';
  const isReturnButtonWhite = visualIvrColors.WHITE === returnButtonTextColor;

  useEffect(() => {
    saveToHistory(categoryName);
  }, []);

  const headerStyle ={
    backgroundImage: actionsPageBackgroundImageFullUrl ? `url(${actionsPageBackgroundImageFullUrl})` : 'none',
    backgroundSize: 'cover',
    backgroundPosition: 'center',
  };

  return (
    <div className='visual-ivr-action-page'>
      <div className='action-page-header' style={headerStyle}>
        <div className='previous-page-btn' onClick={() => setCurrentStep(visualIvrSteps.MENU)}>
          <Image className='previous-page-icon' src={previousPageIcon} style={isReturnButtonWhite ? {filter: 'invert(1)'} : {}} />
          <span className='previous-page-text' style={isReturnButtonWhite ? {color: returnButtonTextColor} : {}}>{previousPageButtonText}</span>
        </div>
      </div>
      {actionsPageTitle && <span className='action-page-title' style={actionsPageTitleColorStr ? {color: actionsPageTitleColorStr} : {}}>{actionsPageTitle}</span>}
      <div className='action-page-actions-container'>
        {categoryActionList?.map((action, index) => (
          <IvrCategoryAction key={index} action={action} />
        ))}
      </div>
    </div>
  );
};

const mapStateToProps = (state) => ({
  categoryData: state.VisualIVRSlice.categoryData,
});

const mapDispatchToProps = {
  setCurrentStep,
  saveToHistory
};
export default connect(mapStateToProps, mapDispatchToProps)(VisualIvrActionsPage);
